var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"px-4"},[_c('DashHeadSearch',{staticClass:"mb-3 mt-3",attrs:{"emitOnly":true},on:{"head-search":_vm.onHeadSearch}})],1),_c('ShoppingSearch',{attrs:{"text":_vm.searchText,"filters":_vm.filters,"orderApproval":true,"itemsToCheckIn":_vm.itemsToCheckIn,"orderId":_vm.orderId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }